import { Button, Flex } from '@chakra-ui/react';
import { useRouter } from 'next/router';

const slug2Word = {
  providers: 'Doctor',
  prescriptions: 'Prescription',
  pharmacies: 'Pharmacy',
};

const AddLink = ({ slug }: { slug: string }) => {
  const router = useRouter();

  return (
    <Flex pt={1}>
      <Button
        variant="link"
        textDecoration="underline"
        onClick={() => router.push(`${slug}?next=recommendations`)}
        color="primary.500"
        mb={2}
        size="sm"
        px={0}
      >
        Add {slug2Word[slug]}
      </Button>
    </Flex>
  );
};

export default AddLink;
